import {createReducer} from "@reduxjs/toolkit";
import {SessionActions} from "./session.action";

const initialState = {
  loading: false,
  error: false,
  details: {}
};

export const SessionReducer = {
  session: createReducer(initialState, (builder => {
    builder
      .addCase(SessionActions.fetchSessionById.pending, (state, _) => {
        console.log('[SessionActions.fetchSessionById.pending]: ')

        return {
          ...state,
          details: {},
          loading: true,
          error: false
        }
      })
      .addCase(SessionActions.fetchSessionById.rejected, (state, _) => {
        console.log('[SessionActions.fetchSessionById.rejected]: ')
        return {
          ...state,
          details: {},
          loading: false,
          error: true
        }
      })
      .addCase(SessionActions.fetchSessionById.fulfilled, (state, {payload}) => {
        console.log('[SessionActions.fetchSessionById.fulfilled]: ', payload)

        return {
          ...state,
          details: payload,
          loading: false,
          error: false,
        }
      })
      .addCase(SessionActions.reset, (state, action) => {
        return initialState
      })
  }))
}
